<template>
    <div class="wrapper_box">
        <div class="post scroll-box" id="post">
            <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
                <home-swiper :swiperList="swiperList"></home-swiper>
                <div class="post_bg">
                    <home-nav></home-nav>
                    <ul class="box_shadow" v-if="isHomepost">
                        <router-link
                            tag="li"
                            v-for="(item,index) in dataList"
                            :key="index"
                            :to="'/postDetail/'+ item.id"
                        >
                            <p class="txt_one">
                                <em class="dis_huo" v-if="item.is_hot">火</em>
                                <!--<em class="dis_tu">圖</em>-->
                                <em class="dis_ding" v-if="item.is_top">頂</em>
                                <em class="dis_jing" v-if="item.is_good">精</em>
                                {{item.title}}
                            </p>
                            <div class="post_content">
                                <div class="left">
                                    <!-- <img src="../assets/img/head.png" alt="" v-if="isHeadSrc"> -->
                                    <img :src="item.user.avatar || defaultPlayerSrc" alt="" v-if="item.user.role_name !== '管理员'">
                                    <img :src="item.user.avatar || defaultAdminSrc" alt="" v-if="item.user.role_name == '管理员'">
                                    <span class="name txt_one">{{item.user.role_name}}</span>
                                    <span class="sname"> <span v-if="item.user.role_name !== '管理员'" class="name_sname txt_one">( {{item.user.sname}} ) </span></span>
                                    <span class="time">{{item.published_at}}</span>
                                </div>
                                <div class="right em_all_icon">
                                    <div><em class="eye"></em><i>{{item.view_count | numberLimit}}</i></div>
                                    <div @click.prevent="like(item)" :class="{current:item.is_liked==true}"><em class="like"></em><i>{{item.like_count | numberLimit}}</i></div>
                                    <div><router-link :to="'/postDetail/'+item.id">
                                        <em class="chat"></em><i>{{item.comment_count | numberLimit}}</i>
                                    </router-link></div>
                                </div>
                            </div>
                        </router-link>
                    </ul>
                </div>
            </mescroll-vue>
        </div>
    </div>
</template>

<script>
import HomeSwiper from '@/components/HomeSwiper.vue'
import HomeNav from '@/components/HomeNav.vue'
import MescrollVue from 'mescroll.js/mescroll.vue'
export default {
    name:'HomePost',
    props:{
        swiperList:Array
    },
    components: {
        MescrollVue,
        HomeSwiper,
        HomeNav
	},
    data () {
        return {
            mescroll: null,
            mescrollDown: {
                textInOffset:'',
                textOutOffset:'',
                textLoading:'Loading...'
            },
            mescrollUp: {
                auto:true,
                callback: this.upCallback,
                noMoreSize: 5,
                htmlLoading:'<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">Loading...</p>'
            },
            dataList: [],
            swiperOption:{
                pagination: '.swiper-pagination',
                loop: true
            },
            defaultPlayerSrc:'../../img/people.png',
            defaultAdminSrc:'../../img/admin.png',
            isHomepost:false
        } 
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo
        }
    },
    filters:{
        numberLimit (value) {
            if(value > 999){
                value = '999+'
            }
            return value
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$ref.mescroll && vm.$refs.mescroll.beforeRouteEnter()
        })
    },
    beforeRouteLeave (to, from, next) {
        this.$refs.mescroll && this.$refs.mescroll.beforeRouteLeave()
    },
    methods: {
        like (item) {
            this.$emit('like',item);
        },
        mescrollInit (mescroll) {
            this.mescroll = mescroll
        },
        downCallback(){
            this.dataList = [];
            this.mescroll.resetUpScroll();
        },
        upCallback (page, mescroll) {
            let api = '/topic/get';
            this.$http.get(api,{
                params:{
                    app_user_id: this.userInfo.app_user_id,
                    category_id:1,
                    game_id: this.userInfo.game_id,
                    page: page.num
                }
            })
            .then((response) => {
                this.isHomepost = true;
                let arr = response.data.data;
                // this.dataList = data;
                if (page.num === 1) this.dataList = []
                this.dataList = this.dataList.concat(arr)
                this.$nextTick(() => {
                    mescroll.endSuccess(arr.length);
                })
            })
            .catch((error) => {
                mescroll.endErr();
            })
        }
    },
    mounted() {
    },
}
</script>

<style lang="stylus" scoped>
@media all and (orientation : landscape)
    .post >>> .swiper-pagination-bullet-active
        background #d2a852
    .post >>> .mescroll-upwarp
        padding 2vh 0 0
    .wrapper_box
        width 100%
        height 100%
    .scroll-box
        position: fixed
        top:0 
        bottom 0
        z-index 1
        margin-left:0
        overflow-y: scroll
    .post
        width 100%
        .post_bg
            background-image: url(/img/bg.ccf7b0ea.jpg)
            background-repeat: repeat-y
            ul
                width: 85%
                height: 100%
                margin: .3rem auto
                padding: .2rem 0 .3rem
                background-color #fff
                li
                    line-height .6rem
                    font-size 0.3rem
                    color #333333
                    text-align left
                    border-bottom 1px solid #cccccc
                    padding 0 0.2rem
                    margin 0 .25rem
                    padding-bottom .08rem
                    cursor pointer
                    a
                        color #fff
                    p
                        overflow: hidden
                        text-overflow:ellipsis
                        white-space: nowrap
                        em {
                            display: inline-block;
                            width: 0.3rem;
                            height: 0.3rem;
                            border-radius: 0.02rem;
                            color: #fff;
                            font-size: 0.205rem;
                            vertical-align: middle;
                            line-height: 0.3rem;
                            text-indent: 0.035rem;
                            margin-left: 1%;
                            font-family: '华文楷体 Bold', '华文楷体 Regular', '华文楷体';
                            &:nth-child(1){
                                margin-left 0 !important
                            }

                            &.dis_huo {
                                background: #f00;
                                margin-left: 0;
                            }

                            &.dis_tu {
                                background: rgba(50, 150, 250, 1);
                            }

                            &.dis_ding {
                                background: rgba(255, 205, 67, 1);
                            }

                            &.dis_jing {
                                background: rgba(25, 161, 95, 1);
                            }
                        }
                    .active
                        color: #19a15f
                    .post_content
                        display flex
                        img
                            width .5rem
                            height .5rem
                            border-radius 100%
                        .left
                            flex 1
                            span
                                display inline-block
                                &.name
                                    width 22%
                                    padding-left 2%
                                    vertical-align middle
                                &.sname
                                    width 22%
                                    padding-left 2%
                                    padding-right 3%
                                    text-align center
                                    vertical-align middle
                                &.name_sname
                                    width 100%
                                    text-align center
                                    vertical-align middle
                                &.time
                                    padding-right 1%
                                    font-size .24rem
                                    color:#999
                        .right
                            flex .6
                            display flex
                            text-align right
                            .span
                                display: inline-block
                                -webkit-box-flex: 1
                                -ms-flex: 1
                                flex: 1
                                color #fff
                                padding-left: 6%
                            div
                                display inline-block
                                flex 1
                                a
                                    color #666666
                                .van-icon
                                    display inline-block
                                    margin-top 0
                                    margin-right 6%
                                    font-size .325rem
                                    color #666666
                                i
                                    display inline-block
                                    font-style normal
                                    vertical-align middle
                                    color: #666666
@media all and (orientation : portrait)
    .post >>> .swiper-pagination-bullet-active
        background #d2a852
    .post >>> .mescroll-upwarp
        padding 2vh 0 0
    .wrapper_box
        position absolute
        width: 100%
        height: auto
    .scroll-box
        position: fixed
        top:7vh 
        bottom 0
        z-index 1
        margin-left:0
        overflow-y: scroll
    .post
        width 100%
        background #333
        .current
            color #d2a852 !important
        ul
            width 100%
            height 100%
            li
                line-height .6rem
                font-size 0.275rem
                color #fff
                text-align left
                border-bottom 1px solid #797979
                padding 0 0.2rem
                padding-bottom .08rem
                a
                    color #fff
                p
                    overflow: hidden
                    text-overflow:ellipsis
                    white-space: nowrap
                .active
                    color: #19a15f
                .post_content
                    display flex
                    img
                        width .45rem
                        height .45rem
                        border-radius 100%
                    .left
                        flex 1
                        span
                            display inline-block
                            &.name
                                width 22%
                                padding-left 2%
                                vertical-align middle
                            &.sname
                                width 22%
                                padding-left 2%
                                padding-right 3%
                                text-align center
                                vertical-align middle
                            &.name_sname
                                width 100%
                                text-align center
                                vertical-align middle
                            &.time
                                padding-right 1%
                                font-size .24rem
                                color:#999
                    .right
                        flex .6
                        display flex
                        text-align right
                        .span
                            display: inline-block
                            -webkit-box-flex: 1
                            -ms-flex: 1
                            flex: 1
                            color #fff
                            padding-left: 6%
                        div
                            display inline-block
                            flex 1
                            a
                                color #666666
                            .van-icon
                                display inline-block
                                margin-top 0
                                margin-right 6%
                                font-size .325rem
                                color #fff
                            i
                                display inline-block
                                font-style normal
                                vertical-align middle

</style>